"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSelectorOptionWrap = exports.StyledLoading = exports.StyledIconWrap = exports.StyledMainInput = exports.StyledContentWrap = exports.StyledAddonWrap = exports.innerInputDisabled = exports.StyledInnerInput = exports.StyledDropdownWrap = exports.StyledDropdown = void 0;
const app_1 = require("@obvio/app");
const Dropdown_1 = require("../Dropdown");
const Form_1 = require("../Form");
const Loading_1 = require("../Loading");
exports.StyledDropdown = (0, app_1.styled)(Dropdown_1.Dropdown) `
  background: white;
`;
exports.StyledDropdownWrap = app_1.styled.div `
  display: flex;
  flex-direction: column;
`;
exports.StyledInnerInput = (0, app_1.styled)(Form_1.TextInput) `
  border: none;
  background: transparent;
  &[aria-disabled='true'] {
    background: transparent;
    opacity: 1;
  }
`;
exports.innerInputDisabled = (0, app_1.css) `
  input {
    opacity: 1 !important;
    pointer-events: none !important;
    cursor: pointer;
  }
`;
exports.StyledAddonWrap = app_1.styled.div `
  color: ${(theme) => theme.colors.gray};
  padding: ${(theme) => `${theme.spacing.small}`};
  font-size: 0.8125rem;
  font-style: italic;
  border-top: ${(theme, { $empty }) => $empty ? 'none' : `0.0625rem solid ${theme.stroke}`};
`;
exports.StyledContentWrap = app_1.styled.div `
  position: relative;
`;
exports.StyledMainInput = (0, app_1.styled)(Form_1.TextInput) `
  ${(_t, { $open, $layerSide }) => $open &&
    $layerSide === 'bottom' &&
    (0, app_1.css) `
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `};
  ${(_t, { $open, $layerSide }) => $open &&
    $layerSide === 'top' &&
    (0, app_1.css) `
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `};
`;
exports.StyledIconWrap = app_1.styled.div `
  position: absolute;
  z-index: 1;
  width: 3.125rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.StyledLoading = (0, app_1.styled)(Loading_1.Loading) `
  padding: ${(theme) => theme.spacing.medium};
`;
exports.StyledSelectorOptionWrap = app_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${(_, { $selectable }) => $selectable
    ? (0, app_1.css) `
          :hover {
            background: ${(theme) => theme.colors.gray.intense};
            cursor: pointer;
          }
        `
    : (0, app_1.css) `
          opacity: 0.2;
          pointer-events: none;
          cursor: not-allowed !important;
        `};

  // Input should take most of the space by default
  // it's div cause of how @obvio/input works
  > div:first-of-type {
    flex: 1;
  }
`;
